/* External dependencies */
import { Container, Div } from 'atomize';
import { Link, Trans } from 'gatsby-plugin-react-i18next';
import React from 'react';

/* Local dependencies */
import DownloadAppButtons, {
  DownloadAppButton,
} from '../../../../components/website/downloadAppButtons/DownloadAppButtons';
import ArrowPointingToTheRightIcon from '../../../../svg/ArrowPointingToTheRightIcon';

interface MobileMenuProps {
  className?: string;
  downloadButtons?: boolean;
}

export default function ArticlesMobileMenu({ className }: MobileMenuProps) {
  const weightIcon = 24;
  const heightIcon = 24;
  const menuList = [
    {
      link: `/`,
      name: <Trans>AboutTheApp</Trans>,
    },
    {
      link: `/for-doctors`,
      name: <Trans>forDoctorsAndClinicsText</Trans>,
    },
  ];
  const app: DownloadAppButton[] = [
    {
      store: 'android',
      link: 'https://play.google.com/store/search?q=medcheck&c=apps&hl=ru',
    },
    {
      store: 'apple',
      link: 'https://apps.apple.com/kg/app/medcheck/id1578873351',
    },
  ];

  return (
    <Div
      h="100vh"
      left="0"
      right="0"
      bg="white"
      className={`article-mobile-menu ${className}`}
      pos="absolute"
      zIndex="5"
      p={{ t: '120px' }}
    >
      {menuList?.map((link, index) => (
        <Div key={index}>
          <Div
            border={{ b: '1px solid' }}
            borderColor="grayTextInCard"
            m={{ b: '24px' }}
            p={{ b: '12px' }}
          >
            <Container>
              <Link to={link.link} className="article-mobile-menu-link">
                {link.name}
                <ArrowPointingToTheRightIcon
                  width={weightIcon}
                  height={heightIcon}
                />
              </Link>
            </Container>
          </Div>
        </Div>
      ))}
      <Div
        pos="absolute"
        w={{ xs: '100%', sm: '50%' }}
        p={{ x: { xs: '20px', sm: '25px' } }}
        bottom="50px"
      >
        <Div
          zIndex="100"
          d="flex"
          justify="space-between"
          m={{ y: '20px' }}
          style={{ gap: '10px' }}
        >
          {app?.map((item, idx) => (
            <Div w="100%" key={idx}>
              <DownloadAppButtons store={item.store} link={item.link} />
            </Div>
          ))}
        </Div>
      </Div>
    </Div>
  );
}
